module.exports = __webpack_public_path__ + "media/images/page/service_logo-sukoyaka-2ce40a87fdf8ab6848f8240e711d332c.png";